import React from 'react';
import {useProject} from "../../providers/ClientProjectProvider";
import PositionCandidateFixedFeeCostOverrideTab from "./PositionCandidateFixedFeeCostOverrideTab";
import PositionCandidateTimeMaterialsCostOverrideTab from "./PositionCandidateTimeMaterialsCostOverrideTab";


/**
 * PositionCandidateCostOverrideTab Component
 *
 * This is a routing component that determines which cost override tab to render
 * based on the project's fee structure. It delegates rendering to specialized
 * components for fixed fee vs time & materials projects.
 *
 * Key Features:
 * - Conditional rendering based on project.isFixedFee()
 * - Delegates to specialized components for cleaner separation of concerns
 * - Maintains backward compatibility with existing interfaces
 *
 * Components:
 * - PositionCandidateFixedFeeCostOverrideTab: For fixed fee projects
 * - PositionCandidateTimeMaterialsCostOverrideTab: For time & materials projects
 */
const PositionCandidateCostOverrideTab = ({...props}) => {
    const {project} = useProject();
    const isFixedFee = project.isFixedFee();
    const isFixedRetainer = project.isFixedRetainer();

    // Route to the appropriate component based on project fee structure

    if (isFixedFee) {
        return <PositionCandidateFixedFeeCostOverrideTab {...props} />;
    }

    return <PositionCandidateTimeMaterialsCostOverrideTab {...props} />;
}


PositionCandidateCostOverrideTab.propTypes = {};

export default PositionCandidateCostOverrideTab;